import React, { useContext } from 'react'
import { AuthContxt } from './AuthContext'
import { Navigate } from 'react-router-dom'

export default function AuthProtectedRoute({children}) {
    const {UserLoggedIn , setUserLoggedIn} = useContext(AuthContxt)

  return <>
     {UserLoggedIn ? <Navigate to ={'/home' }/> : children}

  </>
}
